// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__3uysz","item":"style_item__FnaSl","active":"style_active__ppDkQ"};